var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"extra-checkbox-warp title"},[_c('span',{},[_vm._v(" "+_vm._s(_vm.data.name)+" ")]),_c('checkbox',{attrs:{"shape":"square","checked-color":"#5bad70"},on:{"change":_vm.checkboxChange},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }